export const SET_LANGUAGE: string = 'SET_LANGUAGE';
